import React from "react";
import { Link } from "@jsluna/link";

import { withLinks } from "../selectors";
import { isHidingLinks } from "utils/hideLinks";

export default () => {
  const { helpCentre } = withLinks();

  return (
    !isHidingLinks() && (
      <div className="ln-u-text-align-center ln-u-padding-top*4">
        <p>
          Still having trouble? <Link href={helpCentre}>Contact us</Link>
        </p>
      </div>
    )
  );
};
